<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="ruleCustoms">
      <div slot="toolbar">
        <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open()">新建</el-button>
<!--        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>-->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号">
            <el-input v-model.trim="filter.ruleName" clearable/>
          </vm-search>
          <vm-search label="使用类别">
            <el-select v-model="filter.ruleCategory" clearable>
              <el-option label="蒂升MCX订单" :value="10"/>
              <el-option label="散件导入" :value="20"/>
            </el-select>
          </vm-search>
          <vm-search label="自定义类型">
            <el-select v-model="filter.customType" clearable>
              <el-option label="客户配置物料" :value="0"/>
              <el-option label="控制柜证书编号" :value="1"/>
              <el-option label="一级参数代码" :value="2"/>
              <el-option label="脉冲数" :value="3"/>
              <el-option label="电气原理图1" :value="4"/>
              <el-option label="电气原理图2" :value="5"/>
              <el-option label="UCMP证书编号" :value="6"/>
              <el-option label="马达额定转速" :value="7"/>
              <el-option label="核对人" :value="8"/>
              <el-option label="审核人" :value="9"/>
              <el-option label="板载化" :value="10"/>
              <el-option label="木箱规格" :value="11"/>
              <el-option label="包装箱" :value="12"/>
              <el-option label="随机文件" :value="13"/>
              <el-option label="ARD" :value="14"/>
            </el-select>
          </vm-search>
          <vm-search label="自定义编号">
            <el-input v-model.trim="filter.customerMaterialNo" clearable/>
          </vm-search>
          <vm-search label="自定义描述">
            <el-input v-model.trim="filter.customerMaterialDesc" clearable/>
          </vm-search>
          <vm-search label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="已启用" :value="1"/>
              <el-option label="已停用" :value="0"/>
            </el-select>
          </vm-search>
          <vm-search label="表达式">
            <el-input v-model.trim="filter.ruleExpression" clearable/>
          </vm-search>
          <vm-search label="备注">
            <el-input v-model.trim="filter.note" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="ruleCategoryName" align="center" width="100" label="使用类别" fixed="left"/>
      <el-table-column prop="customTypeName" align="center" width="100" label="自定义类型" fixed="left"/>
      <el-table-column prop="ruleName" align="center" label="编号" width="100"/>
      <el-table-column prop="customerMaterialNo" align="center" width="100" label="自定义编号"/>
      <el-table-column prop="customerMaterialDesc" align="center" width="100" label="自定义描述"/>
      <el-table-column prop="qty" align="center" width="80" label="数量"/>
      <el-table-column prop="unit" align="center" width="80" label="单位"/>
      <el-table-column prop="ruleExpression" align="center" min-width="200" label="表达式"/>
      <el-table-column prop="note" align="center" width="120" label="备注"/>
      <el-table-column prop="statusName" align="center" width="80" label="状态"/>
      <el-table-column prop="creatorName" align="center" width="80" label="创建人"/>
      <el-table-column prop="createTime" align="center" width="140" label="创建时间"/>
      <el-table-column
          label="操作"
          align="center" width="160" fixed="right"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <!--          <el-button type="primary" v-if="editAuth" @click="edit(scope.row,1)">复制</el-button>-->
          <el-button type="primary" v-if="editAuth" :disabled="scope.row.status==1" @click="edit(scope.row,0)">编辑</el-button>
          <el-button type="primary" v-if="editAuth && scope.row.status==0" @click="oneUse(scope.row)">启用</el-button>
          <el-button type="primary" v-if="editAuth  && scope.row.status==1" @click="oneUnuse(scope.row)">停用</el-button>
          <el-button type="danger" v-if="editAuth"  :disabled="scope.row.status==1" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <rule-custom-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import RuleCustomEdit from "@/views/information/RuleCustom/RuleCustomEdit.vue";

  export default {
    name: "RuleCustomList",
    components: {RuleCustomEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        editAuth: this.$auth(513),
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          ruleName: "",
          ruleCategory: 10,
          customType: 0,
          customerMaterialNo: "",
          customerMaterialDesc: "",
          status: "",
          ruleExpression: "",
          note: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "ruleCustoms/delete", ids).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      oneUnuse(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定停用吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "ruleCustoms/status/batchUpdate/0", ids).then(() => {
            this.getList(-1);
            this.$message.success("停用成功");
          });
        });
      },
      oneUse(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定启用吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "ruleCustoms/status/batchUpdate/1", ids).then(() => {
            this.getList(-1);
            this.$message.success("启用成功");
          });
        });
      },
      edit(row, isCopy) {
        this.$refs.editPage.open(row.pkid, isCopy);
      },

      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
